<template>
  <nav class="navbar" id="top">
    <div class="navbar-brand">
      <router-link class="navbar-item" to="/">
        <img src="~@/assets/logo.png" class="logo" alt="The Home Depot Pro">
      </router-link>

      <!-- Menu on tablet -->
      <b-dropdown v-if="isLoggedIn" v-model="activeMenuItem" class="is-hidden-tablet">
        <button class="button is-primary" type="button" slot="trigger">
          <template>
            <b-icon :icon="iconActiveRoute"></b-icon>
            <span>{{ activeRoute }}</span>
          </template>
        </button>

        <b-dropdown-item v-for="item in menuItems" :key="item.name" :has-link="true">
          <router-link :key="item.name"
                       :to='item.route' :replace="true">
            <div class="media">
              <b-icon class="media-left" :icon="item.icon"></b-icon>
              <div class="media-content">
                <h3>{{ item.name }}</h3>
                <!-- <small>{{ item.description }}</small> -->
              </div>
            </div>
          </router-link>
        </b-dropdown-item>

        <hr class="dropdown-divider">

        <b-dropdown-item @click="logOut">
          <div class="media">
            <b-icon class="media-left" icon="power"></b-icon>
            <div class="media-content">
              <h3>Log Out</h3>
            </div>
          </div>
        </b-dropdown-item>
      </b-dropdown>
    </div>

    <!-- Only Desktop -->
    <div v-if="isLoggedIn" class="navbar-menu is-hidden-mobile">
      <div class="navbar-end">
        <!-- Dropdown -->
        <b-dropdown hoverable position="is-bottom-left">
          <a class="navbar-item" slot="trigger">
            <span>{{ loggedUser.email }}</span>
            <b-icon icon="menu-down"></b-icon>
          </a>

          <!-- <b-dropdown-item has-link>
            <div class="field">
              <a @click="receiveEmailNotifications = !receiveEmailNotifications">
                <b-switch :value="receiveEmailNotifications">
                    Receive email notifications
                </b-switch>
              </a>
            </div>
          </b-dropdown-item>
          <hr class="dropdown-divider"> -->
          <b-dropdown-item has-link>
              <a @click="logOut">
                  <i class="mdi mdi-power"></i>
                  Log Out
              </a>
          </b-dropdown-item>
        </b-dropdown>
      </div>
    </div>
  </nav>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'TopNav',
  data() {
    return {
      receiveEmailNotifications: false,
      activeMenuItem: true
    }
  },
  computed: {
    ...mapGetters('auth', [
      'isRoutePublic',
      'isLoggedIn',
      'loggedUser',
      'menuItems'
    ]),
    activeRoute() {
      return this.$route.name === null ? null : this.$route.name.split('.')[0]
    },
    iconActiveRoute() {
      let route =
        this.$route.name === null ? null : this.$route.name.split('.')[0]
      let item = this.menuItems.filter(x => x.name.slice(0, -1) === route)[0]
      return typeof item !== 'undefined' ? item.icon : ''
    }
  },
  methods: {
    ...mapActions('auth', ['logOut']),
    ...mapActions('video', ['getIncompleteVideosCount'])
  },
  created() {
    // Do not load any data is route is public
    if (this.isRoutePublic(this.$route)) return

    // Get statistics
    if (localStorage.token) {
      this.getIncompleteVideosCount()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/BaseTopNav.vue